import { AviaryProvider } from "@fullscript/aviary-web";
import autoplay from "embla-carousel-autoplay";
import useEmblaCarousel from "embla-carousel-react";
import { useMemo } from "react";

import { NewCarousel } from "@aviary/components/NewCarousel/NewCarousel";

import { sideCarouselSlides, type SideCarouselSlide } from "./sideCarouselSlides";
import { VerticalDotNavigation } from "./VerticalDotNavigation/VerticalDotNavigation";

import * as styles from "./SideCarouselPanel.styles";

const AUTOPLAY_DELAY_MS = 10000;

interface Props {
  slides?: SideCarouselSlide[];
}

const SideCarouselPanel = ({ slides = sideCarouselSlides }: Props) => {
  const hasMultipleSlides = slides.length > 1;
  const autoplayPlugins = useMemo(
    () =>
      hasMultipleSlides ? [autoplay({ delay: AUTOPLAY_DELAY_MS, stopOnInteraction: false })] : [],
    [hasMultipleSlides]
  );
  const [emblaRef, emblaApi] = useEmblaCarousel(
    { axis: "y", align: "start", loop: true, watchDrag: hasMultipleSlides },
    autoplayPlugins
  );

  return (
    <AviaryProvider controlledTheme="light" noNormalization>
      <section css={styles.panel}>
        <div css={styles.viewport} ref={emblaRef}>
          <div css={styles.slideColumn}>
            {slides.map(slide => (
              <NewCarousel.Item key={slide.key} customStyles={styles.slideItem}>
                <slide.Slide />
              </NewCarousel.Item>
            ))}
          </div>
        </div>
        {hasMultipleSlides ? (
          <div css={styles.navOverlay}>
            <VerticalDotNavigation emblaApi={emblaApi} />
          </div>
        ) : null}
      </section>
    </AviaryProvider>
  );
};

export { SideCarouselPanel };
